// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202604131333/js/" + chunkId + "." + {"44":"130d8cc0","225":"8e50efec","481":"f8b9ffe8","486":"738b1951","770":"340f356c"}[chunkId] + ".0.673839754137489.chunk.js";
};